import { UserProject } from 'components/Project/types/project';
import { IUserDto, TwoFAEnforcementDto } from 'store/user/types/api-bodies.types';
import { Service } from 'store/user/types/service';
import {
  ICountry, IRegion, UserRole, UserStatus,
} from 'store/user/types/state.types';

class User {
  id: number = 0;

  token: string | null = null;

  tokenExpiresAt: string | null = null;

  role: UserRole = UserRole.Guest;

  fullName: string = '';

  email: string = '';

  status: UserStatus = UserStatus.New;

  loading: boolean = true;

  tempPass?: string;

  tempLogin?: string;

  region: IRegion | null = null;

  regions: IRegion[] = [];

  language: string | null = null;

  isTest: boolean = false;

  state: 'login' | '2fa' | 'expired' | 'success' | 'new' = 'login';

  parentUserId: number | null = null;

  services: Service[] = [];

  currentProject: UserProject | null = null;

  twoFaOn: boolean = false;

  maintenanceEndDate: string | null = null;

  country: ICountry | null = null;

  twoFaEnforcement: TwoFAEnforcementDto | null = null;

  isRootUser: boolean = false;

  constructor(body?: IUserDto) {
    if (!body) return;
    this.id = body.id;
    this.role = body.roleId;
    this.fullName = body.fullName;
    this.email = body.login;
    this.status = body.status;
    this.region = body.currentRegion;
    this.language = body.language;
    this.state = 'success';
    this.parentUserId = body.parentUserId;
    this.isTest = body.isTest;
    this.currentProject = body.currentProject;
    this.country = body.country;
    this.isRootUser = body.isRootUser;
  }
}

export default User;
